// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__sDaEb","Error":"Banner_Error__1xIXN","Success":"Banner_Success__30iR-","Warning":"Banner_Warning__3NEGt"};